export default "__VITE_ASSET__iOJtP9qO__"